import React from "react";
import './index.css';
import Typed from "react-typed";
import ImageHero from '../../../assets/Component 4.png';
import { useNavigate,Link } from "react-router-dom";

function Hero(){
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/signin') 
    }

    return(
        <div className="home-hero-container">
            <div className="home-hero-wrapper">
                <div className="home-hero-izquierda">
                    <span>Descubre, explora y aprende sin límites</span>
                    <div className="typed-container">
                        <span>Accede a:</span>
                        <span className="home-hero-typed">
                            <Typed strings={[
                            "miles de libros.",
                            "gestión de préstamos.",
                            "calificación de libros.",
                            "la mejor experiencia.",
                            ]} typeSpeed={40} backSpeed={50} loop/>
                        </span>
                    </div>
                    <span>
                        Explora una amplia colección de libros y recursos académicos, gestiona tus préstamos de 
                        manera rápida y sencilla, y contribuye a la comunidad calificando tus lecturas favoritas. Ayuda a otros a descubrir y aprovechar el conocimiento que transforma.
                    </span>
                    <div className='home-hero-buttom' onClick={handleNavigate}>
                        <p>Comenzar</p>
                    </div>
                </div>
                <div className="home-hero-derecha">
                    <img src={ImageHero} className="img-parte-derecha"/>    
                </div>
            </div>
        </div>
    )
}

export default Hero;